import React, { useContext, useEffect } from "react";
import CardAgendado from "../../../components/Cards/CardAgendado/Card";
import { Col, Row } from "react-bootstrap";
import { MainContext } from "../../../context/MainContext";
import { PaginationLayout } from "../../PaginationLayout";
import CardToday from "../../../components/Cards/CardToday/CardToday";
import { ClassInfoViewModel } from "../../../domain/viewModel/ClassInfoViewModel";
import styled from "styled-components";

const ClassesThatAreLateListComponent: React.FC = ({}) => {
  const {
    classes, 
    currentPage, 
    loadClassesThatAreLate,
    getSearchInputTextValue} = useContext(MainContext)

  useEffect(() => {
    let isFiltering:boolean = getSearchInputTextValue()!==""

    loadClassesThatAreLate(currentPage,isFiltering)
  }, [currentPage]);

  return (
    <>
      <PaginationLayout
        reload={loadClassesThatAreLate}
        subtitle={
        <ClassesThatAreLateSubtitle
          classes={classes}
        />}
      >
        {classes.map((item: any) => (
          <Col md={"auto"} className="pe-0">
            <CardToday
              percentStudents={item.percentStudents}
              teacherParticipated={item.teacherParticipated}
              date={item.date}
              descrpiton={item.description}
              startTime={item.startTime}
              endTime={item.endTime}
              name={item.name}
              teachers={item.teachers}
              statusClass={item.statusClass}
              hasJoinUrl={item.hasJoinUrl}
              channelWebUrl={item.channelWebUrl}
              joinUrl={item.joinUrl}
            />
          </Col>
        ))}

      </PaginationLayout>
    </>
  );
};

interface ClassesThatAreLateSubtitleProps{
  classes:any[]
}

function ClassesThatAreLateSubtitle ({classes}:ClassesThatAreLateSubtitleProps){
  return (
    <>
        {
          classes.length>0&&
          <SubtitlesStyles md={12}>
            <Row>
              <Col>
                <Row>
                  <Col md='auto'>
                    <i className="bi bi-alarm"  style={{color:"#A56300", fontSize:"3vmin"}}/>
                  </Col>
                  <Col className="my-auto">
                    <span style={{ color: "#A56300" }}>Aula Atrasada</span>
                  </Col>
                </Row>
                <Row>
                  <Col className="my-auto">
                    <h2 >
                      Professor está atrasado menos de 15 minutos
                    </h2>
                  </Col>
                </Row>
              </Col>
              <Col>
                <Row>
                  <Col md='auto'>
                    <i className="bi bi-x-circle"  style={{color:"#D43B26", fontSize:"3vmin"}}/>
                  </Col>
                  <Col className="my-auto">
                    <span style={{ color: "#D43B26" }}>Atraso Critico</span>
                  </Col>
                </Row>
                <Row>
                  <Col className="my-auto">
                    <h2>
                      Professor está atrasado mais de 15 minutos
                    </h2>
                  </Col>
                </Row>
              </Col> 
            </Row>
          </SubtitlesStyles>
        }
    </>
  )
}

const SubtitlesStyles = styled(Col)`
  h2{
    font-family: "Segoe UI";
    font-style: normal;
    font-weight: 400;
    font-size: 1.7vmin;
    line-height: 2.22vmin;
    color: rgb(74, 74, 74);
  }
`
export default ClassesThatAreLateListComponent;
